import React from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';
import { ff } from '@atlassian/jira-feature-flagging';
import { CardEpic } from '@atlassian/jira-platform-board-kit';
import Summary from '@atlassian/jira-software-deployments-common-table/src/components/summary';
import type { IssueId } from '@atlassian/jira-software-deployments-common-table/src/model/issue';
import { useIssue } from '../../../services/core-data/main';
import { useIssueTypesLookup } from '../../../services/get-project';

type Props = {
	id: IssueId;
};

const ListItemContent = ({ id }: Props) => {
	const issue = useIssue(id);
	if (!issue) {
		throw new Error('issue not found but is required for ListItemContent');
	}

	const issueTypes = useIssueTypesLookup();
	const { epic } = issue;
	const { iconUrl, name } = issueTypes[issue.typeId];
	return (
		<ListItemContentContainer>
			{ff('a11y-jira-team.deployment-filter-and-table_m845b') ? (
				<Summary title={issue.summary} issue={issue.key} iconUrl={iconUrl} typeName={name} />
			) : (
				<Tooltip content={`${issue.key}: ${issue.summary}`} position="top-start">
					<Summary title={issue.summary} issue={issue.key} iconUrl={iconUrl} typeName={name} />
				</Tooltip>
			)}
			{epic && (
				<ParentWrapper>
					<CardEpic color={epic.color}>{epic.summary}</CardEpic>
				</ParentWrapper>
			)}
		</ListItemContentContainer>
	);
};

export default ListItemContent;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ListItemContentContainer = styled.div({
	display: 'flex',
	alignItems: 'center',
	overflow: 'hidden',
	width: '100%',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ParentWrapper = styled.div({
	paddingLeft: token('space.100', '8px'),
	display: 'flex',
});
